export default __webpack_public_path__ + "static/media/clouds-2.ee051410.png";